<template>

    <div
        v-if="products.length > 0"
        class="row productscontainer mt-5 mb-5"
    >
        <div
            v-for="product in products"
            :key="product.uuid"
            class="col-6 col-md-4 col-lg-3"
        >
            <overview-item
                :product="product"
            ></overview-item>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import OverviewItem from "../Products/OverviewItem.vue";

export default {

    components: {
        OverviewItem,
    },

    data() {
        return {
            products: [],
        }
    },

    methods: {
        getData() {
            axios.get(this.route('api.v1.products.index', {
                type: this.type,
                uuid: this.uuid,
            }))
                .then((resp) => this.products = resp.data.data)
        },
    },

    mounted() {
        if (['brand', 'category'].indexOf(this.type) === -1) {
            return;
        }

        this.getData();
    },

    props: {
        type: {
            required:true,
            type:String,
        },
        uuid: {
            required:true,
            type:String,
        },
    }

}

</script>
